import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import {FormControl,FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OauthService, ProgramService, UserService } from '@terradotta/commons';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {
  @Input() primaryColor: string;
  @Input() loginRegistrationOptions: any;
  @Input() rcValue:number;
  @Input() programId: number;
  @Input() i18nFields: any;
  @Input() redirectURL: string;
  @Input() userId: number;
  @Input() tempPW: string;
  loadingSpinner: boolean = false;
  hidePassWord = true;
  hidePassWordConfirm = true;
  hideTempPassWord = true;
  userLoggedIn: boolean = false;
  pwMin:number;
  requiredPasswordLength: number;
  pwMixed: string = '';
  pwNum: string = '';
  pwSpecChar: string = '';
  pwReqs: string = '';
  pwHasNumber: boolean = false;
  pwHasMixed: boolean = false;
  pwHasSpChar: boolean = false;
  tdNewPasswordForm: FormGroup;
  loginResponse: any;

  @Output() activeAppCycleResults: EventEmitter<any> = new EventEmitter<any>();
  @Output() formMode: EventEmitter<any> = new EventEmitter<any>();

  constructor(private fb: FormBuilder,
    private _oauthService: OauthService,
    private snackbar: MatSnackBar,
    private _cookieService: CookieService,
    private _programService: ProgramService,
    private _userService: UserService
) { }

  ngOnInit(): void {
    var that = this;
    if(this.userId){
      this.userLoggedIn = true;
    }
    // this.loadingSpinner = true
    this.pwMin = this.loginRegistrationOptions.passwordMinCharLength
    if(this.loginRegistrationOptions.requirePasswordMixedCase){
      this.pwMixed = '(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])';
    }
    if(this.loginRegistrationOptions.requirePasswordNumber){
      this.pwNum = '(?=.*[0-9])';
    }
    if(this.loginRegistrationOptions.requirePasswordCharacter){
      this.pwSpecChar = '(?=.*[~`!@#$%^&*+=-[];,/{}|":<>?()._])';
    }    
    this.pwReqs = this.pwMixed+this.pwNum+this.pwSpecChar+'.{'+this.pwMin+',}';
    this.tdNewPasswordForm = this.createNewPasswordForm();
    let passwordValidators: any[] = [Validators.required];
    if(this.pwMin > 0){
      passwordValidators.push(Validators.minLength(this.pwMin))
    }
    if(this.loginRegistrationOptions.requirePasswordNumber){
      passwordValidators.push(this.authNumPassword)
    }
    if(this.loginRegistrationOptions.requirePasswordMixedCase){
      passwordValidators.push(this.authMixedPassword)
    }
    if(this.loginRegistrationOptions.requirePasswordCharacter){
      passwordValidators.push(this.authSCPassword)
    }
    if(this.tempPW){
      passwordValidators.push(this.authMatchTemp(this.tempPW));      
    } 

    this.tdNewPasswordForm.get('tdPassword').setValidators(passwordValidators);
    
    if(this.userLoggedIn){
      this.tdNewPasswordForm.setValidators([this.checkPasswords]);
    }else {
      this.tdNewPasswordForm.setValidators([this.checkPasswords,this.checkTempMatch]);
    }

  }

  createNewPasswordForm(){
    if(this.userLoggedIn){
      return this.fb.group({
        tdPassword:['', Validators.required],      
        tdPasswordConfirm:['', Validators.required],        
      });
    } else {
      return this.fb.group({
        tdEmail: ['', [Validators.required, Validators.email]],  
        tdTempPassword:[''],      
        tdPassword:[''],      
        tdPasswordConfirm:[''],
      });
    }    
  }
  checkPasswords(tdNewPasswordForm: FormGroup) { // here we have the 'passwords' group
    let pass = tdNewPasswordForm.get('tdPassword').value;
    let confirmPass = tdNewPasswordForm.get('tdPasswordConfirm').value;
    if(pass !== confirmPass){
      tdNewPasswordForm.get('tdPasswordConfirm').setErrors({notMatch:true});
    } else {
      tdNewPasswordForm.get('tdPasswordConfirm').setErrors(null);
    }
    
    return pass === confirmPass ? null : { notMatch:true }
  }
  checkTempMatch(tdNewPasswordForm: FormGroup) { // here we have the 'passwords' group
  let pass = tdNewPasswordForm.get('tdPassword').value;
  let tempPass = tdNewPasswordForm.get('tdTempPassword').value;
  // if(pass === tempPass){
  //   tdNewPasswordForm.get('tdPassword').setErrors({sameTemp:true});
  // } else {
  //   tdNewPasswordForm.get('tdPassword').setErrors(null);
  // }
  return pass !== tempPass ? null : { sameTemp:true }
}
  
  authMatchTemp(tempPass: string){
    return function(control: FormControl){
      if(!control.pristine){
        let pass = control.value;
        let tPass = pass === tempPass;
        
        if(tPass){
          return {sameTemp:true};
        } else {
          return null;
        } 
      } else {
        return null;
      }
    }
   
  }
  authNumPassword(control: FormControl){
    if(!control.pristine){
      let pass = control.value;
      const pwNoNumber = !/\d/.test(pass);
      
      if(pwNoNumber){
        return {pwNoNumber:true};
      } else {
        return null;
      } 
    } else {
      return null;
    }
  }
  authMixedPassword(control: FormControl){
    if(!control.pristine){
      let pass = control.value;
      const pwNoMixed = !/(?=.*[a-z])(?=.*[A-Z])/.test(pass);
      if(pwNoMixed){
        return {pwNoMixed:true};
      } else {
        return null;
      }     
    } else {
      return null;
    }
  }
  authSCPassword(control:FormControl){
    if(!control.pristine){
      let pass = control.value;
      const pwNoSC = !/[\s~`!@#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?()\._]/.test(pass);
      if(pwNoSC){
        return {pwNoSC:true};
      } else {
        return null;
      }     
    } else {
      return null;
    }
  }
  userPasswordUpdate(){
      this.loadingSpinner = true;
      let newPassword = {
        userPassword: this.tdNewPasswordForm.get('tdPassword').value,
      }    
      if(this.rcValue > 0){
        var RC = this.rcValue
      }  
      if(this.userLoggedIn){
        this._userService.userNewPassword(this.userId, newPassword).subscribe(resp => {
          if(this.rcValue > 0){
            var RC = this.rcValue
          }
          if(this.redirectURL !== ''){
            window.location.href = window.location.origin + '/' + this.redirectURL        
          } else {      
            window.location.href = window.location.origin + '/index.cfm?FuseAction=Portal.Home';
          }
        },err => {        
          let msg: string = 'There were an error while trying to update your password. Please try again. ';      
          this.snackbar.open(msg,'Dismiss',{
            duration: 6000
          });
          this.loadingSpinner = false;
        })
      } else {
            let tdUserInfo = {
              userName: this.tdNewPasswordForm.get('tdEmail').value,
              userPassword: this.tdNewPasswordForm.get('tdTempPassword').value,
              RC              
            } 
            this._oauthService.userLogin(tdUserInfo).subscribe(res => {
              this.loginResponse = res;      
              this._oauthService.getToken(true).then((token) => {
                if(token){
                  this._userService.userNewPassword(res.userId, newPassword).subscribe(resp => {
                    // if(this.programId > 0){
                    //   this._programService.getApplyAppCycles(this.programId, this.loginResponse.userId).subscribe(data => {
                    //     this.activeAppCycleResults.emit(data);
                    //     // this.redirectURL.emit(this.loginResponse.returnURL)
                    //     this.formMode.emit('appCycleSelect');
                    //   }) 
                    // }else {
                      this.loginRedirect();
                    // }
                  },err => {        
                    let msg: string = 'There were an error while trying to update your password. Please try again. ';      
                    this.snackbar.open(msg,'Dismiss',{
                      duration: 6000
                    });
                    this.loadingSpinner = false;
                  })
                }
              });
                  
              },err => {
                if(err.status === 401){
                  this.tdNewPasswordForm.patchValue({
                    tdUsername:'',
                    tdTempPassword:''
                  })
                  let msg: string = 'There was an error while trying to login. Check your username and temporary password and try again. ';      
                    this.snackbar.open(msg,'Dismiss',{
                      duration: 4500
                    });
                }
                this.loadingSpinner = false;
              })
                        
                     
      }
    }

  loginRedirect(){
    if(this.loginResponse.returnURL !== ''){
      window.location.href = window.location.origin + '/' + this.loginResponse.returnURL        
    } else {      
      window.location.href = window.location.origin + '/index.cfm?FuseAction=Portal.Home';
    }
}
}
